import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {BrowserRouter as Router, Link, Route, Switch} from 'react-router-dom';
/* Tax */
import TaxesPage from './Tax/TaxesPage';
import TaxesRatesPage from './Tax/TaxesRatesPage';
import AddTaxPage from './Tax/AddTaxPage';
import UpdateTaxRatePage from './Tax/UpdateTaxRatePage';
import TaxGroupsPage from './Tax/TaxGroupsPage';
import AddTaxGroupPage from './Tax/AddTaxGroupPage';
import AddTaxToGroupPage from './Tax/AddTaxToGroupPage';
import UpdateTaxPage from './Tax/UpdateTaxPage';
import UpdateTaxGroupPage from './Tax/UpdateTaxGroupPage';
import RemoveTaxFromGroupPage from './Tax/RemoveTaxFromGroupPage';
/* Category */
import CategoriesPage from './Category/CategoriesPage';
import AddCategoryPage from './Category/AddCategoryPage';
import UpdateCategoryPage from './Category/UpdateCategoryPage';
import InventoryByCategoryReportPage from './Category/InventoryByCategoryReportPage';
/* Product */
import ProductsPage from './Product/ProductsPage';
import ProductToReorderListPage from './Product/ProductToReorderListPage';
import AddProductPage from './Product/AddProductPage';
import ChangeProductPricePage from './Product/ChangeProductSalePricePage';
import ReceiveProductPage from './Product/ReceiveProductPage';
import AdjustProductPage from './Product/AdjustProductPage';
import UpdateProductPage from './Product/UpdateProductPage';
import ProductLabelPage from './Product/ProductLabelPage';
import StocksPage from './Product/StocksPage';
import ProductHistoryPage from "./Product/ProductHistoryPage";
import BatchesPage from "./Product/BatchesPage";
import CorrectReceivedProductPage from "./Product/CorrectReceivedProductPage";
/* Stock-take */
import StockTakesPage from './StockTake/StockTakesPage';
import TakeStockTakePage from './StockTake/TakeStockTakePage';
import StockTakeDiscrepanciesPage from './StockTake/StockTakeDiscrepanciesPage';
import StockTakeUncountedPage from './StockTake/StockTakeUncountedPage';
import StockTakeHistoryPage from './StockTake/StockTakeHistoryPage';
/* Bulk Product */
import BulkProductsPage from './BulkProduct/BulkProductsPage';
import AddBulkProductPage from './BulkProduct/AddBulkProductPage';
import UpdateBulkProductPage from './BulkProduct/UpdateBulkProductPage';
/* Bulk Consignment */
import BulkConsignmentsPage from './BulkConsignment/BulkConsignmentsPage';
import ReceiveBulkProductPage from './BulkConsignment/ReceiveBulkProductPage';
import BulkConsignmentPage from './BulkConsignment/BulkConsignmentPage';
import UpdateReceivedBulkProductPage from "./BulkConsignment/UpdateReceivedBulkProductPage";
/* Discount Reason */
import AddDiscountReasonPage from "./DiscountReason/AddDiscountReasonPage";
import UpdateDiscountReasonPage from "./DiscountReason/UpdateDiscountReasonPage";
import DiscountReasonsPage from "./DiscountReason/DiscountReasonsPage";
/* Discount Rate Limit */
import StaffRoleDiscountRateLimitsPage from "./StaffRoleDiscountRateLimit/StaffRoleDiscountRateLimitsPage";
import UpdateStaffRoleDiscountRateLimitPage from "./StaffRoleDiscountRateLimit/UpdateStaffRoleDiscountRateLimitPage";
/* Staff Role */
import AddStaffRolePage from "./StaffRole/AddStaffRolePage";
import UpdateStaffRolePage from "./StaffRole/UpdateStaffRolePage";
import StaffRolesPage from "./StaffRole/StaffRolesPage";
/* Staff */
import StaffsPage from './Staff/StaffsPage';
import AddStaffPage from './Staff/AddStaffPage';
import FireStaffPage from './Staff/FireStaffPage';
import UpdateStaffPage from './Staff/UpdateStaffPage';
/* TillLimit */
import SetTillLimitPage from './TillLimit/SetTillLimitPage';
/* SellLimit */
import SellLimitsPage from './SellLimit/SellLimitsPage';
import AddSellLimitPage from "./SellLimit/AddSellLimitPage";
import EditSellLimitPage from "./SellLimit/EditSellLimitPage";
import DeleteSellLimitPage from "./SellLimit/DeleteSellLimitPage";
/* Dispensary */
import DispensaryListPage from './Dispensary/DispensaryListPage';
import AddDispensaryPage from './Dispensary/AddDispensaryPage';
import UpdateDispensaryPage from './Dispensary/UpdateDispensaryPage';
/* Brands */
import BrandsPage from './Brand/BrandsPage';
import AddBrandPage from './Brand/AddBrandPage';
import UpdateBrandPage from './Brand/UpdateBrandPage';
/* Suppliers */
import SuppliersPage from './Supplier/SuppliersPage';
import AddSupplierPage from './Supplier/AddSupplierPage';
import UpdateSupplierPage from './Supplier/UpdateSupplierPage';
/* Purchase Orders */
import PurchaseOrdersPage from './PurchaseOrder/PurchaseOrdersPage';
import PurchaseOrderPage from './PurchaseOrder/PurchaseOrderPage';
import AddPurchaseOrderPage from './PurchaseOrder/AddPurchaseOrderPage';
import AddProductToPurchaseOrderPage from './PurchaseOrder/AddProductToPurchaseOrderPage';
import UpdatePurchaseOrderProductPage from './PurchaseOrder/UpdatePurchaseOrderProductPage';
import SubmitPurchaseOrderPage from './PurchaseOrder/SubmitPurchaseOrderPage';
import ConfirmPurchaseOrderPage from './PurchaseOrder/ConfirmPurchaseOrderPage';
import ReceivePurchaseOrderPage from './PurchaseOrder/ReceivePurchaseOrderPage';
import CancelPurchaseOrderPage from './PurchaseOrder/CancelPurchaseOrderPage';
/* Tills */
import TillsPage from './Till/TillsPage';
import AddTillPage from './Till/AddTillPage';
import UpdateTillPage from './Till/UpdateTillPage';
/* Auth */
import LoginPage from "./Auth/LoginPage";
import SessionManager from "./Auth/SessionManager";
import LogoutPage from "./Auth/LogoutPage";
/* User */
import UsersPage from './User/UsersPage';
import ChangePasswordPage from './User/ChangePasswordPage';
import AddUserPage from "./User/AddUserPage";
import UpdateUserPage from "./User/UpdateUserPage";
/* Regulatory Body */
import RegulatoryBodiesPage from "./RegulatoryBody/RegulatoryBodiesPage";
import AddRegulatoryBodyPage from "./RegulatoryBody/AddRegulatoryBodyPage";
import UpdateRegulatoryBodyPage from "./RegulatoryBody/UpdateRegulatoryBodyPage";
import RegulatoryBodyReportingCategoriesPage from "./RegulatoryBody/ReportingCategory/ReportingCategoriesPage";
import AddRegulatoryBodyReportingCategoryPage from "./RegulatoryBody/ReportingCategory/AddReportingCategoryPage";
/* Regulatory Reporting */
import RegulatoryReportingTypesPage from "./RegulatoryReporting/RegulatoryReportingTypesPage";
import AddRegulatoryReportingTypePage from "./RegulatoryReporting/AddRegulatoryReportingTypePage";
import ReportingTypeAssociationsPage from "./Dispensary/RegulatoryReporting/ReportingTypeAssociationsPage";
/* Fee */
import FeesPage from "./Fee/FeesPage";
import AddFeePage from "./Fee/AddFeePage";
import UpdateFeePage from "./Fee/UpdateFeePage";
import FeeRatesPage from "./Fee/FeeRatesPage";
import AddFeeRatePage from "./Fee/AddFeeRatePage";
import FeeApplicableProductsPage from "./Fee/FeeApplicableProductsPage";
/* Reports */
import CategoriesReport from "./Category/CategoriesReport";
import SuppliersReport from "./Supplier/SuppliersReport";
import ProductToReorderReport from "./Product/ProductToReorderReport";
import TransactionHistoryReportPage from "./Reports/TransactionHistoryReportPage";
import GrossProfitReportPage from "./Reports/GrossProfitReportPage";
import DiscountsByReasonReportPage from "./Reports/DiscountsByReasonReportPage";
import ReturnsReportPage from "./Reports/ReturnsReportPage";
/* Return Reasons */
import ReturnReasonsPage from "./ReturnReason/ReturnReasonsPage";
import AddReturnReasonPage from "./ReturnReason/AddReturnReasonPage";
import UpdateReturnReasonPage from "./ReturnReason/UpdateReturnReasonPage";

import logo from "./images/indigenet-g2s_full_grey.png";
import "./App.css";

import {Button, Drawer, Icon, Layout, Menu} from 'antd';
import DispensarySelector from "./Dispensary/DispensarySelector";
import TillLimitsPage from "./TillLimit/TillLimitsPage";

import {version} from './version.js';
import PrivateRoute from "./PrivateRoute";
import Auth from "./services/auth";
import {HIDE_NEW_CONTENT_DRAWER} from "./reducers/appUpdate";
import StartStockTakePage from "./StockTake/StartStockTakePage";
import Screen from './utils/screen';

const {Header, Content, Footer, Sider} = Layout;
const SubMenu = Menu.SubMenu;

const LandingPage = () => null;

function redirectToIndigenet() {
  if (window.location.hostname.includes("legacy420.advancetech.io")) {
    window.location = 'https://legacy420.indigenetg2s.ca' + window.location.pathname + window.location.search;
  }
}

class App extends Component {
  static propTypes = {
    auth: PropTypes.object,
    selectedDispensaryId: PropTypes.string,
    showNewAppContentDrawer: PropTypes.bool.isRequired,
    /* actions */
    hideNewContentDrawer: PropTypes.func.isRequired,
  };

  state = {
    collapsed: false,
    screenWidth: 0,
  };

  componentDidMount() {
    redirectToIndigenet();
    Screen.registerWatcher(this.onResize);
  }

  componentWillUnmount() {
    Screen.unregisterWatcher(this.onResize);
  }

  componentDidUpdate() {
    redirectToIndigenet();
  }

  onResize = () => {
    this.setState({screenWidth: Screen.width});
  };

  isMobile = () => this.state.screenWidth <= 768;

  onMenuItemClicked = () => {
    if (this.isMobile()) {
      this.setState({collapsed: true});
    }
  };

  onCloseNewAppContentDrawer = () => {
    this.props.hideNewContentDrawer();
  };

  onClickRefresh = (e) => {
    e.preventDefault();
    window.location.reload(true);
  };

  displayMenu = (...children) => {
    const {collapsed} = this.state;
    if (this.isMobile()) {
      return (
        <Header>
          <Drawer
            placement="left"
            closable={false}
            className="menu-drawer"
            visible={!collapsed}
            width={205}
            height="100%"
            onClose={() => this.setState({collapsed: true})}
          >
            {children}
          </Drawer>
          <Button icon="menu-unfold" onClick={() => this.setState({collapsed: false})} />
          <span>IndigenetG2S Inventory</span>
        </Header>
      );
    }
    return (
      <Sider width={205}>
        {children}
      </Sider>
    );
  };

  render() {
    const {selectedDispensaryId, auth} = this.props;
    const isAdmin = auth.hasPermission('admin');
    const canSeeReports = auth.hasPermission('reports');
    const showSider = auth.isAuthenticated();
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <Layout id="page">
          <Drawer
            placement="top"
            visible={this.props.showNewAppContentDrawer}
            destroyOnClose={true}
            mask={false}
            width="100%"
            height="100"
            onClose={this.onCloseNewAppContentDrawer}
          >
            New version available. Please reload the page.
            &nbsp;
            <Button type="primary" onClick={this.onClickRefresh}>Reload</Button>
          </Drawer>
          <SessionManager />
          {showSider && this.displayMenu(
            <DispensarySelector key="dispensarySelector" />,
            <Menu
                key="menu"
                mode="inline"
                onClick={this.onMenuItemClicked}
            >
              <Menu.Item key="changePassword">
                <Icon type="key"/>
                <span><Link to="/user/changePassword">Change Password</Link></span>
              </Menu.Item>
              <Menu.Item key="logout">
                <Icon type="logout"/>
                <span><Link to="/logout">Logout</Link></span>
              </Menu.Item>
              <SubMenu
                  key="dispensary"
                  title={<span><Icon type="home"/><span>Dispensary</span></span>}
              >
                <Menu.Item key="dispensary-list">
                  <Link to="/dispensary/list">Dispensary List</Link>
                </Menu.Item>
                {selectedDispensaryId && isAdmin && [
                  <Menu.Item key="sellLimits">
                    <Link to="/sell-limit/list">Sell Limits</Link>
                  </Menu.Item>,
                ]}
                {selectedDispensaryId && [
                  <Menu.Item key="tills">
                    <Link to="/till/list">Tills</Link>
                  </Menu.Item>,
                ]}
                {selectedDispensaryId && [
                  <Menu.Item key="returnReasons">
                    <Link to="/return-reason/list">Return Reasons</Link>
                  </Menu.Item>
                ]}
              </SubMenu>
              {selectedDispensaryId && <SubMenu
                key="fee"
                title={<span><Icon type="environment"/><span>Fees</span></span>}
              >
                <Menu.Item key="fees">
                  <Link to="/fee/list">Fee List</Link>
                </Menu.Item>
              </SubMenu>}
              <SubMenu
                key="pricing"
                title={<span><Icon type="calculator"/><span>Pricing</span></span>}
              >
                <Menu.Item key="discount-rate-limit">
                  <Link to="/discount-rate-limit/list">Discount Limits</Link>
                </Menu.Item>
                <Menu.Item key="discount-reasons">
                  <Link to="/discount-reason/list">Discount Reasons</Link>
                </Menu.Item>
              </SubMenu>
              {selectedDispensaryId && <SubMenu
                key="product"
                title={<span><Icon type="barcode"/><span>Products</span></span>}
              >
                <Menu.Item key="brands">
                  <Link to="/brand/list">Brands</Link>
                </Menu.Item>
                <Menu.Item key="bulkConsignments">
                  <Link to="/bulk-consignment/list">Bulk Consignments</Link>
                </Menu.Item>
                <Menu.Item key="bulkProducts">
                  <Link to="/bulk-product/list">Bulk Product List</Link>
                </Menu.Item>
                <Menu.Item key="categories">
                  <Link to="/category/list">Categories</Link>
                </Menu.Item>
                <Menu.Item key="products">
                  <Link to="/product/list">Product List</Link>
                </Menu.Item>
                <Menu.Item key="purchaseOrders">
                  <Link to="/purchase-order/list">Purchase Orders</Link>
                </Menu.Item>
                <Menu.Item key="productToReorderList">
                  <Link to="/product/reorder-list">Reorder List</Link>
                </Menu.Item>
                <Menu.Item key="stockTakes">
                  <Link to="/stock-take/list">Stock-takes</Link>
                </Menu.Item>
                <Menu.Item key="suppliers">
                  <Link to="/supplier/list">Suppliers</Link>
                </Menu.Item>
              </SubMenu>}
              {isAdmin &&
              <SubMenu key="regulatory-reporting" title={<span><Icon type="table"/><span>Reporting</span></span>}>
                <Menu.Item key="regulatory-reporting/list-bodies">
                  <Link to="/regulatory-reporting/list-bodies">Bodies</Link>
                </Menu.Item>
                <Menu.Item key="regulatory-reporting-list-types">
                  <Link to="/regulatory-reporting/list-types">Types</Link>
                </Menu.Item>
              </SubMenu>
              }
              <SubMenu key="staff" title={<span><Icon type="team"/><span>Staff</span></span>}>
                {selectedDispensaryId &&
                <Menu.Item key="staffs">
                  <Link to="/staff/list">Staff</Link>
                </Menu.Item>
                }
                <Menu.Item key="staffRole-list">
                  <Link to="/staff-role/list">Roles</Link>
                </Menu.Item>
              </SubMenu>
              {selectedDispensaryId && <SubMenu
                  key="tax"
                  title={<span><Icon type="bank"/><span>Taxes</span></span>}
              >
                <Menu.Item key="taxGroups">
                  <Link to="/tax/groups">Groups</Link>
                </Menu.Item>
                <Menu.Item key="taxes">
                  <Link to="/tax/list">Tax List</Link>
                </Menu.Item>
              </SubMenu>}
              {isAdmin &&
              <SubMenu key="users" title={<span><Icon type="laptop"/><span>Users</span></span>}>
                <Menu.Item key="user-list">
                  <Link to="/user/list">User List</Link>
                </Menu.Item>
              </SubMenu>
              }
              {selectedDispensaryId && canSeeReports &&
              <SubMenu key="reports" title={<span><Icon type="book"/><span>Reports</span></span>}>
                <Menu.Item key="report-inventory-by-category">
                  <Link to="/reports/inventory-by-category">Inventory by Category</Link>
                </Menu.Item>
                <Menu.Item key="report-categories">
                  <Link to="/reports/categories">Categories</Link>
                </Menu.Item>
                <Menu.Item key="report-suppliers">
                  <Link to="/reports/suppliers">Suppliers</Link>
                </Menu.Item>
                <Menu.Item key="report-product-to-reorder">
                  <Link to="/reports/product-to-reorder">Product to reorder</Link>
                </Menu.Item>
                <Menu.Item key="report-transaction-history">
                  <Link to="/reports/transaction-history">Transaction history</Link>
                </Menu.Item>
                <Menu.Item key="report-gross-profit">
                  <Link to="/reports/gross-profit">Gross profit</Link>
                </Menu.Item>
                <Menu.Item key="report-discounts-by-reason">
                  <Link to="/reports/discounts-by-reason">Discounts Given</Link>
                </Menu.Item>
                <Menu.Item key="report-returns">
                  <Link to="/reports/returns">Returns</Link>
                </Menu.Item>
              </SubMenu>
              }
            </Menu>
          )}
          <Layout>
            <Content id="content">
              <Switch>
                <PrivateRoute exact path="/" auth={auth} component={LandingPage}/>
                <Route exact path="/login" component={LoginPage}/>
                <Route exact path="/logout" component={LogoutPage}/>
                {/* Dispensary */}
                <PrivateRoute exact path="/dispensary/list" auth={auth} component={DispensaryListPage}/>
                <PrivateRoute exact path="/dispensary/add" auth={auth} component={AddDispensaryPage}/>
                <PrivateRoute exact path="/dispensary/update/:dispensaryId" auth={auth} component={UpdateDispensaryPage}/>
                <PrivateRoute exact path="/dispensary/reporting-type-association/:dispensaryId" auth={auth} component={ReportingTypeAssociationsPage}/>
                {/* Discount Reason */}
                <PrivateRoute exact path="/discount-reason/list" auth={auth} component={DiscountReasonsPage}/>
                <PrivateRoute exact path="/discount-reason/add" auth={auth} component={AddDiscountReasonPage}/>
                <PrivateRoute exact path="/discount-reason/update/:discountReasonId" auth={auth} component={UpdateDiscountReasonPage}/>
                {/* Discount Rate Limit */}
                <PrivateRoute exact path="/discount-rate-limit/list" auth={auth} component={StaffRoleDiscountRateLimitsPage}/>
                <PrivateRoute exact path="/discount-rate-limit/update/:staffRoleId" auth={auth} component={UpdateStaffRoleDiscountRateLimitPage}/>
                {/* Staff Role */}
                <PrivateRoute exact path="/staff-role/list" auth={auth} component={StaffRolesPage}/>
                <PrivateRoute exact path="/staff-role/add" auth={auth} component={AddStaffRolePage}/>
                <PrivateRoute exact path="/staff-role/update/:staffRoleId" auth={auth} component={UpdateStaffRolePage}/>
                {/* Tax */}
                <PrivateRoute exact path="/tax/list" auth={auth} component={TaxesPage}/>
                <PrivateRoute exact path="/tax/rates/:taxId" auth={auth} component={TaxesRatesPage}/>
                <PrivateRoute exact path="/tax/groups" auth={auth} component={TaxGroupsPage}/>
                <PrivateRoute exact path="/tax/add" auth={auth} component={AddTaxPage}/>
                <PrivateRoute exact path="/tax/update-rate/:taxId" auth={auth} component={UpdateTaxRatePage}/>
                <PrivateRoute exact path="/tax/add-group" auth={auth} component={AddTaxGroupPage}/>
                <PrivateRoute exact path="/tax/add-to-group/:taxGroupId" auth={auth} component={AddTaxToGroupPage}/>
                <PrivateRoute exact path="/tax/update/:taxId" auth={auth} component={UpdateTaxPage}/>
                <PrivateRoute exact path="/tax/update-group/:taxGroupId" auth={auth} component={UpdateTaxGroupPage}/>
                <PrivateRoute exact path="/tax/remove-from-group/:taxGroupId" auth={auth} component={RemoveTaxFromGroupPage}/>
                {/* Category */}
                <PrivateRoute exact path="/category/list" auth={auth} component={CategoriesPage}/>
                <PrivateRoute exact path="/category/add" auth={auth} component={AddCategoryPage}/>
                <PrivateRoute exact path="/category/update/:categoryId" auth={auth} component={UpdateCategoryPage}/>
                {/* Product */}
                <PrivateRoute exact path="/product/list" auth={auth} component={ProductsPage}/>
                <PrivateRoute exact path="/product/reorder-list" auth={auth} component={ProductToReorderListPage}/>
                <PrivateRoute exact path="/product/add" auth={auth} component={AddProductPage}/>
                <PrivateRoute exact path="/product/change-price/:productId" auth={auth} component={ChangeProductPricePage}/>
                <PrivateRoute exact path="/product/receive/:productId/:purchaseId" auth={auth} component={ReceiveProductPage}/>
                <PrivateRoute exact path="/product/adjust/:productId/:sku" auth={auth} component={AdjustProductPage}/>
                <PrivateRoute exact path="/product/update/:productId" auth={auth} component={UpdateProductPage}/>
                <PrivateRoute exact path="/product/history/:productId" auth={auth} component={ProductHistoryPage}/>
                <PrivateRoute exact path="/product/label/:productId/:sku" auth={auth} component={ProductLabelPage}/>
                <PrivateRoute exact path="/product/stocks/:productId" auth={auth} component={StocksPage}/>
                <PrivateRoute exact path="/product/batches/:productId/:sku" auth={auth} component={BatchesPage}/>
                <PrivateRoute exact path="/product/correct-batch/:productId/:sku/:receivedAt" auth={auth}
                              component={CorrectReceivedProductPage}/>
                {/* Stock-take */}
                <PrivateRoute exact path="/stock-take/list" auth={auth} component={StockTakesPage}/>
                <PrivateRoute exact path="/stock-take/start" auth={auth} component={StartStockTakePage}/>
                <PrivateRoute exact path="/stock-take/take/:stockTakeId" auth={auth} component={TakeStockTakePage}/>
                <PrivateRoute exact path="/stock-take/take/:stockTakeId/:sku" auth={auth} component={TakeStockTakePage}/>
                <PrivateRoute exact path="/stock-take/discrepancies/:stockTakeId" auth={auth} component={StockTakeDiscrepanciesPage}/>
                <PrivateRoute exact path="/stock-take/uncounted/:stockTakeId" auth={auth} component={StockTakeUncountedPage}/>
                <PrivateRoute exact path="/stock-take/history/:stockTakeId" auth={auth} component={StockTakeHistoryPage}/>
                {/* Bulk Product */}
                <PrivateRoute exact path="/bulk-product/list" auth={auth} component={BulkProductsPage}/>
                <PrivateRoute exact path="/bulk-product/add" auth={auth} component={AddBulkProductPage}/>
                <PrivateRoute exact path="/bulk-product/update/:bulkProductId" auth={auth} component={UpdateBulkProductPage}/>
                {/* Bulk Consignment */}
                <PrivateRoute exact path="/bulk-consignment/list" auth={auth} component={BulkConsignmentsPage}/>
                <PrivateRoute exact path="/bulk-consignment/receiveBulkProduct" auth={auth} component={ReceiveBulkProductPage}/>
                <PrivateRoute exact path="/bulk-consignment/update/:bulkConsignmentId" auth={auth} component={UpdateReceivedBulkProductPage}/>
                <PrivateRoute exact path="/bulk-consignment/packs/:bulkConsignmentId" auth={auth} component={BulkConsignmentPage}/>
                {/* Staff */}
                <PrivateRoute exact path="/staff/list" auth={auth} component={StaffsPage}/>
                <PrivateRoute exact path="/staff/add" auth={auth} component={AddStaffPage}/>
                <PrivateRoute exact path="/staff/fire/:staffId" auth={auth} component={FireStaffPage}/>
                <PrivateRoute exact path="/staff/update/:staffId" auth={auth} component={UpdateStaffPage}/>
                {/* Brand */}
                <PrivateRoute exact path="/brand/list" auth={auth} component={BrandsPage}/>
                <PrivateRoute exact path="/brand/add" auth={auth} component={AddBrandPage}/>
                <PrivateRoute exact path="/brand/update/:brandId" auth={auth} component={UpdateBrandPage}/>
                {/* Suppliers */}
                <PrivateRoute exact path="/supplier/list" auth={auth} component={SuppliersPage}/>
                <PrivateRoute exact path="/supplier/add" auth={auth} component={AddSupplierPage}/>
                <PrivateRoute exact path="/supplier/update/:supplierId" auth={auth} component={UpdateSupplierPage}/>
                {/* TillLimit */}
                <PrivateRoute exact path="/till-limit/list" auth={auth} component={TillLimitsPage} />
                <PrivateRoute exact path="/till-limit/set" auth={auth} component={SetTillLimitPage}/>
                {/* SellLimit */}
                <PrivateRoute exact path="/sell-limit/list" auth={auth} component={SellLimitsPage}/>
                <PrivateRoute exact path="/sell-limit/add" auth={auth} component={AddSellLimitPage}/>
                <PrivateRoute exact path="/sell-limit/:sellLimitId/edit" auth={auth} component={EditSellLimitPage}/>
                <PrivateRoute exact path="/sell-limit/:sellLimitId/delete" auth={auth} component={DeleteSellLimitPage}/>
                {/* Purchase Orders */}
                <PrivateRoute exact path="/purchase-order/list" auth={auth} component={PurchaseOrdersPage}/>
                <PrivateRoute exact path="/purchase-order/add" auth={auth} component={AddPurchaseOrderPage}/>
                <PrivateRoute exact path="/purchase-order/:purchaseId" auth={auth} component={PurchaseOrderPage}/>
                <PrivateRoute exact path="/purchase-order/add-product/:purchaseId" auth={auth} component={AddProductToPurchaseOrderPage}/>
                <PrivateRoute exact path="/purchase-order/update-product/:purchaseId/:productId" auth={auth} component={UpdatePurchaseOrderProductPage}/>
                <PrivateRoute exact path="/purchase-order/submit/:purchaseId" auth={auth} component={SubmitPurchaseOrderPage}/>
                <PrivateRoute exact path="/purchase-order/confirm/:purchaseId" auth={auth} component={ConfirmPurchaseOrderPage}/>
                <PrivateRoute exact path="/purchase-order/receive/:purchaseId" auth={auth} component={ReceivePurchaseOrderPage}/>
                <PrivateRoute exact path="/purchase-order/cancel/:purchaseId" auth={auth} component={CancelPurchaseOrderPage}/>
                {/* Tills */}
                <PrivateRoute exact path="/till/list" auth={auth} component={TillsPage}/>
                <PrivateRoute exact path="/till/add" auth={auth} component={AddTillPage}/>
                <PrivateRoute exact path="/till/update/:tillId" auth={auth} component={UpdateTillPage}/>
                {/* User */}
                <PrivateRoute exact path="/user/list" auth={auth} requirePermission="admin" component={UsersPage}/>
                <PrivateRoute exact path="/user/add" auth={auth} requirePermission="admin" component={AddUserPage}/>
                <PrivateRoute exact path="/user/update/:userId" auth={auth} requirePermission="admin" component={UpdateUserPage}/>
                <PrivateRoute exact path="/user/changePassword" auth={auth} component={ChangePasswordPage}/>
                {/* Regulatory Body */}
                <PrivateRoute exact path="/regulatory-reporting/list-bodies" auth={auth} requirePermission="admin" component={RegulatoryBodiesPage}/>
                <PrivateRoute exact path="/regulatory-reporting/add-body" auth={auth} requirePermission="admin" component={AddRegulatoryBodyPage}/>
                <PrivateRoute exact path="/regulatory-reporting/update-body/:regulatoryBodyId" auth={auth} requirePermission="admin" component={UpdateRegulatoryBodyPage}/>
                <PrivateRoute exact path="/regulatory-reporting/body/categories/:regulatoryBodyId" auth={auth} requirePermission="admin" component={RegulatoryBodyReportingCategoriesPage}/>
                <PrivateRoute exact path="/regulatory-reporting/body/add-category/:regulatoryBodyId" auth={auth} requirePermission="admin" component={AddRegulatoryBodyReportingCategoryPage}/>
                {/* Regulatory Reporting */}
                <PrivateRoute exact path="/regulatory-reporting/list-types" auth={auth} requirePermission="admin" component={RegulatoryReportingTypesPage}/>
                <PrivateRoute exact path="/regulatory-reporting/add-type" auth={auth} requirePermission="admin" component={AddRegulatoryReportingTypePage}/>
                {/* Fee */}
                <PrivateRoute exact path="/fee/list" auth={auth} component={FeesPage}/>
                <PrivateRoute exact path="/fee/add" auth={auth} component={AddFeePage}/>
                <PrivateRoute exact path="/fee/update/:feeId" auth={auth} component={UpdateFeePage}/>
                <PrivateRoute exact path="/fee/rates/:feeId" auth={auth} component={FeeRatesPage}/>
                <PrivateRoute exact path="/fee/add-rate/:feeId" auth={auth} component={AddFeeRatePage}/>
                <PrivateRoute exact path="/fee/applicable-products/:feeId" auth={auth} component={FeeApplicableProductsPage}/>
                {/* Reports */}
                <PrivateRoute exact path="/reports/inventory-by-category" auth={auth} requirePermission="reports" component={InventoryByCategoryReportPage}/>
                <PrivateRoute exact path="/reports/categories" auth={auth} requirePermission="reports" component={CategoriesReport}/>
                <PrivateRoute exact path="/reports/suppliers" auth={auth} requirePermission="reports" component={SuppliersReport}/>
                <PrivateRoute exact path="/reports/product-to-reorder" auth={auth} requirePermission="reports" component={ProductToReorderReport}/>
                <PrivateRoute exact path="/reports/transaction-history" auth={auth} requirePermission="reports" component={TransactionHistoryReportPage}/>
                <PrivateRoute exact path="/reports/gross-profit" auth={auth} requirePermission="reports" component={GrossProfitReportPage}/>
                <PrivateRoute exact path="/reports/discounts-by-reason" auth={auth} requirePermission="reports" component={DiscountsByReasonReportPage}/>
                <PrivateRoute exact path="/reports/returns" auth={auth} requirePermission="reports" component={ReturnsReportPage}/>
                {/* Return Reasons */}
                <PrivateRoute exact path="/return-reason/list" auth={auth} component={ReturnReasonsPage}/>
                <PrivateRoute exact path="/return-reason/add" auth={auth} component={AddReturnReasonPage}/>
                <PrivateRoute exact path="/return-reason/update/:returnReasonId" auth={auth} component={UpdateReturnReasonPage}/>
              </Switch>
            </Content>
            <Footer id="footer">
              Inventory (rev {version}) ©{new Date().getFullYear()} <img src={logo} className="indigenet-logo" alt="" />
            </Footer>
          </Layout>
        </Layout>
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  auth: new Auth(state.auth.token),
  selectedDispensaryId: state.dispensary.selectedDispensaryId,
  showNewAppContentDrawer: state.appUpdate.newAppContentAvailable && !state.appUpdate.hideNewContentDrawer,
});

const mapDispatchToProps = dispatch => ({
  hideNewContentDrawer: () => (dispatch({type: HIDE_NEW_CONTENT_DRAWER}))
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js